<template>
  <div>
    <span class="muted--text">
      {{ $t("signin:signinform.identityHint.label", "Choose account") }}
    </span>
    <v-radio-group
      v-model="identityHint"
      :disabled="loading"
      dense
      :row="!column"
      mandatory
      class="pt-2 mt-0"
    >
      <v-radio
        v-for="n in identityHints"
        :key="n"
        :label="n"
        :value="n"
      ></v-radio>
    </v-radio-group>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";
export default defineComponent({
  name: "IdentityHints",
  props: {
    value: {
      type: String,
      default: null
    },
    identityHints: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    column: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    identityHint: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  fragments: {
    identityHintsSignIn: gql`
      fragment _ on personSignInPayload {
        identityHints
      }
    `,
    identityHintsResetPassword: gql`
      fragment _ on personSendPasswordResetLinkPayload {
        identityHints
      }
    `
  }
});
</script>
